"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _get2 = _interopRequireDefault(require("lodash/get"));
require("./myAccount.scss");
var _icons = require("@angi/icons");
var _withRouter = _interopRequireDefault(require("react-router/lib/withRouter"));
var _react = _interopRequireDefault(require("react"));
var _reactHelmetAsync = _interopRequireDefault(require("react-helmet-async"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _myAccount2 = _interopRequireDefault(require("../analytics/myAccount"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));
var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));
var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _personalDetails = _interopRequireDefault(require("../../../common/browser/components/myAccount/personalDetails"));
var _addressInformation = _interopRequireDefault(require("../../../common/browser/components/myAccount/addressInformation"));
var _contactPreferences = _interopRequireDefault(require("../../../common/browser/components/myAccount/contactPreferences"));
var memberMgmtActions = _interopRequireWildcard(require("../../../common/actions/memberMgmtGatewayActions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var editButtonStyle = 'primary-office';
var cancelButtonStyle = 'default-office';
var SP_TYPE_ADS = 'Ads';
var SP_TYPE_LEADS = 'Leads';
var SP_TYPE_DUAL = 'Dual';
var SP_TYPE_NONE = 'None';
var determineSpType = function determineSpType(entitlements) {
  var serviceProvider = entitlements.filter(function (ent) {
    return ent.scope === 'ServiceProvider';
  });
  var hasLeads = serviceProvider.filter(function (ent) {
    return ent.permission === 'AngiLeadsAdmin';
  }).length;
  var hasAds = serviceProvider.filter(function (ent) {
    return ent.permission !== 'AngiLeadsAdmin';
  }).length;
  if (hasAds && hasLeads) {
    return SP_TYPE_DUAL;
  } else if (hasAds && !hasLeads) {
    return SP_TYPE_ADS;
  } else if (!hasAds && hasLeads) {
    return SP_TYPE_LEADS;
  } else {
    return SP_TYPE_NONE;
  }
};

// This must be a 'class' and not a pure render method so that HMR will work
/* eslint react/prefer-stateless-function: 0 */
var MyAccountContainer = /*#__PURE__*/function (_React$Component) {
  function MyAccountContainer() {
    (0, _classCallCheck2["default"])(this, MyAccountContainer);
    return _callSuper(this, MyAccountContainer, arguments);
  }
  (0, _inherits2["default"])(MyAccountContainer, _React$Component);
  return (0, _createClass2["default"])(MyAccountContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$memberMan = _this$props.memberManagementGateway,
        fetchUser = _this$props$memberMan.fetchUser,
        deleteUserAddress = _this$props$memberMan.deleteUserAddress,
        setPrimaryAddress = _this$props$memberMan.setPrimaryAddress,
        changePassword = _this$props$memberMan.changePassword,
        deleteUserAddressApi = _this$props.deleteUserAddress,
        setPrimaryAddressApi = _this$props.setPrimaryAddress,
        changeUserPasswordApi = _this$props.changeUserPassword,
        resetChangeUserPassword = _this$props.resetChangeUserPassword,
        showContactPrefModal = _this$props.showContactPrefModal,
        userInfo = _this$props.user.userInfo,
        router = _this$props.router;
      var email = (0, _get2["default"])(userInfo, 'response.email');
      var userId = (0, _get2["default"])(userInfo, 'response.userId');
      var spType = determineSpType((0, _get2["default"])(userInfo, 'response.entitlements', []));
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactHelmetAsync["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, "Business Center - Account")), /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        bsStyle: "link",
        id: "edit-credit-card-back-button",
        bsSize: "small",
        onClick: router.goBack
      }, /*#__PURE__*/_react["default"].createElement(_icons.ArrowLeftIcon, {
        id: "edit-credit-card-back-arrow",
        height: 10
      }), /*#__PURE__*/_react["default"].createElement("span", null, " Back")), /*#__PURE__*/_react["default"].createElement("h2", {
        id: "my-account-personal-settings-header"
      }, "Personal account settings"), /*#__PURE__*/_react["default"].createElement("p", null, "These settings are for your individual Angi account. They won't impact your business settings or any affiliated team members' account. "), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_personalDetails["default"], {
        editButtonStyle: editButtonStyle,
        fetchUser: fetchUser,
        changePassword: changePassword,
        changeUserPasswordApi: changeUserPasswordApi,
        resetChangeUserPassword: resetChangeUserPassword
      }), /*#__PURE__*/_react["default"].createElement(_addressInformation["default"], {
        editButtonStyle: editButtonStyle,
        fetchUser: fetchUser,
        deleteUserAddress: deleteUserAddress,
        setPrimaryAddress: setPrimaryAddress,
        deleteUserAddressApi: deleteUserAddressApi,
        setPrimaryAddressApi: setPrimaryAddressApi
      }), spType === SP_TYPE_ADS || spType === SP_TYPE_DUAL ? /*#__PURE__*/_react["default"].createElement(_contactPreferences["default"], {
        editButtonStyle: editButtonStyle,
        cancelButtonStyle: cancelButtonStyle,
        userId: userId,
        email: email,
        showContactPrefModal: showContactPrefModal
      }) : null))));
    }
  }]);
}(_react["default"].Component);
MyAccountContainer.propTypes = {
  memberManagementGateway: _propTypes["default"].shape({
    fetchUser: _propTypes["default"].object.isRequired,
    deleteUserAddress: _propTypes["default"].object.isRequired,
    setPrimaryAddress: _propTypes["default"].object.isRequired,
    changePassword: _propTypes["default"].object.isRequired
  }).isRequired,
  user: _propTypes["default"].shape({
    userInfo: _propTypes["default"].object.isRequired
  }).isRequired,
  deleteUserAddress: _propTypes["default"].func.isRequired,
  setPrimaryAddress: _propTypes["default"].func.isRequired,
  changeUserPassword: _propTypes["default"].func.isRequired,
  resetChangeUserPassword: _propTypes["default"].func.isRequired,
  showContactPrefModal: _propTypes["default"].bool.isRequired,
  router: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _angieslistAppPlatform.withAuthentication)({}), (0, _angieslistAppPlatform.analytics)({
  ruleset: _myAccount2["default"]
}), _withRouter["default"], (0, _reactRedux.connect)(function (state) {
  return {
    memberManagementGateway: state.memberManagementGateway,
    user: state.user
  };
}, _objectSpread({}, memberMgmtActions)), _pure["default"])(MyAccountContainer);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/office/browser/containers/myAccount.js
// module id = 4056
// module chunks = 9